import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Home,
  Calendar,
  CalendarCheck,
  Users,
  Mail,
  Star,
  BarChart3,
  Receipt,
  Settings,
  LogOut,
  UserCheck
} from 'lucide-react';

const DoctorSidebar = () => {
  const location = useLocation(); // Ottieni il percorso corrente
  
  // Ottenere le informazioni dell'utente dal localStorage
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const firstName = user.first_name || '';
  const lastName = user.last_name || '';
  const userId = user.id || '';

  // Funzione helper per determinare se un link è attivo
  const isActive = (path) => location.pathname.includes(path);

  return (
    <div className="flex flex-col h-full">
      {/* Intestazione con informazioni del dottore */}
      <div className="p-4 border-b border-gray-200">
        <div className="flex items-center">
          <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center mr-3">
            <UserCheck className="w-5 h-5 text-purple-600" />
          </div>
          <div>
            <h3 className="font-medium text-gray-800">{firstName} {lastName} (#{userId})</h3>
          </div>
        </div>
      </div>

      <nav className="mt-6 flex-grow">
        <Link
          to="/doctor/dashboard"
          className={`flex items-center px-4 py-2 transition-colors ${isActive('/doctor/dashboard')
              ? 'bg-purple-100 text-purple-700'
              : 'hover:bg-purple-100 text-gray-700'
            }`}
        >
          <Home className="w-5 h-5 mr-3" />
          <span className="text-lg font-medium">Dashboard</span>
        </Link>

        <Link
          to="/doctor/appointments"
          className={`flex items-center px-4 py-2 transition-colors ${isActive('/doctor/appointments')
              ? 'bg-purple-100 text-purple-700'
              : 'hover:bg-purple-100 text-gray-700'
            }`}
        >
          <Calendar className="w-5 h-5 mr-3" />
          <span className="text-lg font-medium">Appuntamenti</span>
        </Link>

        <Link
          to="/doctor/calendar"
          className={`flex items-center px-4 py-2 transition-colors ${isActive('/doctor/calendar')
              ? 'bg-purple-100 text-purple-700'
              : 'hover:bg-purple-100 text-gray-700'
            }`}
        >
          <CalendarCheck className="w-5 h-5 mr-3" />
          <span className="text-lg font-medium">Calendario</span>
        </Link>

        <Link
          to="/doctor/patient"
          className={`flex items-center px-4 py-2 transition-colors ${isActive('/doctor/patient')
              ? 'bg-purple-100 text-purple-700'
              : 'hover:bg-purple-100 text-gray-700'
            }`}
        >
          <Users className="w-5 h-5 mr-3" />
          <span className="text-lg font-medium">Pazienti</span>
        </Link>

        <Link
          to="/doctor/messages"
          className={`flex items-center px-4 py-2 transition-colors ${isActive('/doctor/messages')
              ? 'bg-purple-100 text-purple-700'
              : 'hover:bg-purple-100 text-gray-700'
            }`}
        >
          <Mail className="w-5 h-5 mr-3" />
          <span className="text-lg font-medium">Messaggi</span>
        </Link>

        <Link
          to="/doctor/feedback"
          className={`flex items-center px-4 py-2 transition-colors ${isActive('/doctor/feedback')
              ? 'bg-purple-100 text-purple-700'
              : 'hover:bg-purple-100 text-gray-700'
            }`}
        >
          <Star className="w-5 h-5 mr-3" />
          <span className="text-lg font-medium">Feedback</span>
        </Link>

        <Link
          to="/doctor/stats"
          className={`flex items-center px-4 py-2 transition-colors ${isActive('/doctor/stats')
              ? 'bg-purple-100 text-purple-700'
              : 'hover:bg-purple-100 text-gray-700'
            }`}
        >
          <BarChart3 className="w-5 h-5 mr-3" />
          <span className="text-lg font-medium">Statistiche</span>
        </Link>

        <Link
          to="/doctor/billing"
          className={`flex items-center px-4 py-2 transition-colors ${isActive('/doctor/billing')
              ? 'bg-purple-100 text-purple-700'
              : 'hover:bg-purple-100 text-gray-700'
            }`}
        >
          <Receipt className="w-5 h-5 mr-3" />
          <span className="text-lg font-medium">Rendicontazione</span>
        </Link>

        <Link
          to="/doctor/settings"
          className={`flex items-center px-4 py-2 transition-colors ${isActive('/doctor/settings')
              ? 'bg-purple-100 text-purple-700'
              : 'hover:bg-purple-100 text-gray-700'
            }`}
        >
          <Settings className="w-5 h-5 mr-3" />
          <span className="text-lg font-medium">Impostazioni</span>
        </Link>

        <Link
          to="/logout"
          className={`flex items-center px-4 py-2 transition-colors ${isActive('/logout')
              ? 'bg-purple-100 text-purple-700'
              : 'hover:bg-purple-100 text-gray-700'
            }`}
        >
          <LogOut className="w-5 h-5 mr-3" />
          <span className="text-lg font-medium">Logout</span>
        </Link>

        {/* Pulsante di assistenza */}
        <div className="h-6"></div>
        <div className="p-4">
          <a
            href="mailto:help@personaltherapy.it"
            className="block bg-purple-600 text-white p-4 rounded-lg shadow-lg hover:bg-purple-700 transition-colors text-center"
          >
            <h3 className="font-bold">Hai bisogno di assistenza?</h3>
            <p className="text-sm">Scrivi subito a help@personaltherapy.it!</p>
          </a>
        </div>

      </nav>
    </div>
  );
};

export default DoctorSidebar;